module.exports = __webpack_public_path__ + "img/18.afb259c4.png";